export const prices = { 
    demo: { mo_1: 0.00, mo_3: 0.00, mo_6: 0.00, yr_1: 0.00, yr_2: 0.00, yr_3: 0.00, min_mo_price: 0.00  } ,
    start: { mo_1: 10.00, mo_3: 27.00, mo_6: 48.00, yr_1: 67.20, yr_2: 115.20, yr_3: 144.00, min_mo_price: 5.00  }, 
    standard: { mo_1: 18.00, mo_3: 48.60, mo_6: 86.40, yr_1: 120.96, yr_2: 207.36, yr_3: 259.20, min_mo_price: 9.00  }, 
    premium: { mo_1: 32.00, mo_3: 86.40, mo_6: 153.60, yr_1: 215.04, yr_2: 368.64, yr_3: 460.80, min_mo_price: 16.00  },
    additionalUsers: { regularPrice: 100.00, studentPrice: 10.00 },
    currency: 'RSD',
    conversionRate: 117.39,
    discount: { perc: 0, validTo: '21.04.2026' }
}


// WEBPACK FOOTER //
// ./src/config/prices.js